var _defs, _path, _g, _g2, _g3, _path2, _g4, _g5, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMillarMccallWylieLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "millar-mccall-wylie-logo_svg__logo-mmw-main",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 253 300"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "millar-mccall-wylie-logo_svg__b",
    x1: -86.91,
    y1: 469.05,
    x2: -84.37,
    y2: 469.05,
    gradientTransform: "rotate(90 4421.385 6390.475) scale(22.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee743b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#ee743b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87441e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "millar-mccall-wylie-logo_svg__d",
    x1: -84.3,
    y1: 471.93,
    x2: -81.75,
    y2: 471.93,
    gradientTransform: "matrix(0 -22.66 22.66 0 -10643.87 -1852.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4d7c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#e4d7c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b7a99c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "millar-mccall-wylie-logo_svg__f",
    x1: -86.91,
    y1: 468,
    x2: -84.37,
    y2: 468,
    gradientTransform: "rotate(90 4429.095 6398.185) scale(22.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e84133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#e84133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#962d1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "millar-mccall-wylie-logo_svg__h",
    x1: -84.3,
    y1: 472.98,
    x2: -81.75,
    y2: 472.98,
    gradientTransform: "rotate(-90 -6240.32 4388.12) scale(22.66)",
    xlinkHref: "#millar-mccall-wylie-logo_svg__d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "millar-mccall-wylie-logo_svg__j",
    x1: -84.3,
    y1: 474.02,
    x2: -81.75,
    y2: 474.02,
    gradientTransform: "rotate(-90 -6232.61 4380.41) scale(22.66)",
    xlinkHref: "#millar-mccall-wylie-logo_svg__d"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "millar-mccall-wylie-logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "millar-mccall-wylie-logo_svg__a",
    d: "M195.54 0l-39.11 57.61h18.36L213.9 0h-18.36z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "millar-mccall-wylie-logo_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "millar-mccall-wylie-logo_svg__a",
    d: "M39.11 0h18.36v57.61H39.11z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "millar-mccall-wylie-logo_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    className: "millar-mccall-wylie-logo_svg__a",
    d: "M234.65 0l-39.11 57.61h18.35L253 0h-18.35z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "millar-mccall-wylie-logo_svg__g"
  }, /*#__PURE__*/React.createElement("path", {
    className: "millar-mccall-wylie-logo_svg__a",
    d: "M78.22 0h18.35v57.61H78.22z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "millar-mccall-wylie-logo_svg__i"
  }, /*#__PURE__*/React.createElement("path", {
    className: "millar-mccall-wylie-logo_svg__a",
    d: "M117.32 0h18.36v57.61h-18.36z"
  })), /*#__PURE__*/React.createElement("style", null, ".millar-mccall-wylie-logo_svg__a{fill:none}.millar-mccall-wylie-logo_svg__b{fill:#1d1d1b}.millar-mccall-wylie-logo_svg__q{fill:#ebe2c9}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "millar-mccall-wylie-logo_svg__b",
    d: "M52.03 134.76V95.19l-16.19 39.57h-9.13L10.52 95.51v39.25H.04V78.31h14.45l16.9 40.77 16.52-40.77h14.92v56.45h-10.8zM80.13 76.16a6.53 6.53 0 11-6.51 6.61 6.51 6.51 0 016.51-6.61m-5.24 19.43h10.56v39.17H74.89zM96.72 77.11h10.56v57.65H96.72zM118.55 77.11h10.56v57.65h-10.56zM149.42 112.23l9.61-1.44c2.22-.31 2.94-1.43 2.94-2.78 0-2.79-2.15-5.1-6.59-5.1-4.61 0-7.14 3-7.46 6.37l-9.37-2c.63-6.13 6.27-12.9 16.75-12.9 12.38 0 17 7 17 14.89v19.27a43.61 43.61 0 00.48 6.21h-9.68a26.33 26.33 0 01-.4-4.7c-2 3.11-5.71 5.82-11.51 5.82-8.33 0-13.41-5.66-13.41-11.79 0-7 5.16-10.91 11.66-11.86m12.56 6.7v-1.76l-8.81 1.36c-2.7.4-4.85 1.91-4.85 4.93 0 2.31 1.67 4.54 5.08 4.54 4.45 0 8.58-2.15 8.58-9.07M206.73 106.1a15.74 15.74 0 00-3.17-.32c-5.4 0-10.08 2.63-10.08 11.06v17.92h-10.56V95.59h10.24v5.81c2.38-5.18 7.78-6.13 11.11-6.13.88 0 1.67.08 2.46.15zM52.03 209.44v-39.57l-16.19 39.57h-9.13l-16.19-39.26v39.26H.04v-56.45h14.45l16.91 40.76 16.51-40.76h14.92v56.45h-10.8zM82.27 189.85c0 7.09 4.61 11.07 10 11.07a8.94 8.94 0 009-6.61l9.29 3.11c-1.75 6.52-7.86 13.21-18.26 13.21-11.5 0-20.55-8.75-20.55-20.78S80.6 169.07 92 169.07c10.64 0 16.67 6.61 18.34 13.22l-9.45 3.18c-.95-3.26-3.42-6.61-8.66-6.61s-9.92 3.91-9.92 11M115.77 181.25c0-18 13.57-29.46 28.65-29.46 15.56 0 23.58 9.56 25.8 18.71l-10.32 3.27c-1.35-5.42-5.72-11.39-15.48-11.39-8.41 0-17.3 6.05-17.3 18.87 0 12 8.41 18.63 17.46 18.63 9.6 0 14.29-6.29 15.8-11.54l10.24 3.1c-2.15 8.68-10.24 19.19-26 19.19s-28.81-11.38-28.81-29.38M187.12 186.91l9.61-1.44c2.22-.32 2.94-1.43 2.94-2.79 0-2.78-2.15-5.09-6.59-5.09-4.61 0-7.15 2.94-7.46 6.37l-9.37-2c.63-6.13 6.27-12.9 16.75-12.9 12.38 0 17 7 17 14.89v19.27a43.61 43.61 0 00.48 6.21h-9.68a26.5 26.5 0 01-.4-4.7c-2 3.1-5.71 5.82-11.51 5.82-8.33 0-13.41-5.66-13.41-11.79 0-7 5.16-10.91 11.66-11.86m12.55 6.68v-1.75l-8.82 1.36c-2.7.39-4.84 1.91-4.84 4.93 0 2.31 1.67 4.54 5.08 4.54 4.45 0 8.58-2.15 8.58-9.08M220.62 151.79h10.56v57.65h-10.56zM242.45 151.79H253v57.65h-10.55zM68.47 228.1h11.19L64.1 284.56H52.83l-12.86-40.22-12.86 40.22H15.68L.04 228.1h11.59l10.32 38.86 12.46-38.86h11.35l12.55 39.02 10.16-39.02zM87.19 300l9.21-20.38-16.59-34.24h11.83l10.4 22.93 9.6-22.93h11.27L98.39 300h-11.2zM129.34 226.91h10.56v57.65h-10.56zM156.41 226a6.53 6.53 0 11-6.51 6.61 6.51 6.51 0 016.51-6.61m-5.24 19.43h10.55v39.17h-10.55zM208 273.33c-2 6.77-8.18 12.42-17.78 12.42-10.71 0-20.16-7.72-20.16-20.94 0-12.5 9.21-20.63 19.21-20.63 12.06 0 19.29 7.73 19.29 20.31 0 1.51-.16 3.11-.16 3.26h-27.94c.24 5.18 4.6 8.92 9.84 8.92 4.92 0 7.62-2.47 8.89-6zm-9.84-12.82c-.16-3.9-2.7-7.73-8.73-7.73a8.46 8.46 0 00-8.73 7.73z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#millar-mccall-wylie-logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#millar-mccall-wylie-logo_svg__b)",
    d: "M156.43 0h57.47v57.61h-57.47z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#millar-mccall-wylie-logo_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#millar-mccall-wylie-logo_svg__d)",
    d: "M39.11 0h18.36v57.61H39.11z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#millar-mccall-wylie-logo_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#millar-mccall-wylie-logo_svg__f)",
    d: "M195.54 0H253v57.61h-57.46z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f39b9b",
    d: "M57.46 0H39.11L0 57.61h18.36L57.46 0z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#millar-mccall-wylie-logo_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#millar-mccall-wylie-logo_svg__h)",
    d: "M78.22 0h18.35v57.61H78.22z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#millar-mccall-wylie-logo_svg__i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#millar-mccall-wylie-logo_svg__j)",
    d: "M117.32 0h18.36v57.61h-18.36z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#42a572",
    d: "M96.57 0H78.22L39.11 57.61h18.36L96.57 0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4891",
    d: "M135.68 0h-18.36l-39.1 57.61h18.35L135.68 0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M174.79 0h-18.36l-39.11 57.61h18.36L174.79 0z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "millar-mccall-wylie-logo_svg__q",
    d: "M156.43 0h18.36v57.6h-18.36zM195.54 0h18.36v57.6h-18.36z"
  })));
}
export default SvgMillarMccallWylieLogo;